import dayjs from 'dayjs';

export const subscribeFormat = (date: string) => {
	return dayjs(date).format('YYYY-MM-DD HH:mm');
};
